<template>
    <td class="kgr-table__cell">
        <kgr-money-input
            :value="value"
            @post-input="onInput"
            @error="$emit('error', $event)"
        />
        <div
            v-if="hasError"
            class="kgr-color kgr-color--error"
        >
            {{ errorMessage }}
        </div>
    </td>
</template>

<script>
import Error from '../../../js/model/Error';
import LegacyMoneyInput from '../../common/form/input/LegacyMoneyInput';

export default {
    components: {
        'kgr-money-input': LegacyMoneyInput,
    },
    props: {
        value: {
            type: Number,
            required: false,
        },
        field: {
            type: String,
            required: true,
        },
        error: {
            type: Error,
            required: false,
        },
    },
    computed: {
        hasError() {
            return this.error.forField(this.field);
        },
        errorMessage() {
            return this.$t(this.error.messageForField(this.field));
        },
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
